import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginLayoutComponent } from '@core/layout/login-layout/login-layout.component';
import { LoginLayoutService } from '@core/services/login-layout.service';
import { Subject, takeUntil } from 'rxjs';
import { InputModule } from '../../../../shared/components/input/input.module';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { SignupService } from '@feature/auth/services/signup.service';
import { MessageHandlerService } from '@core/services/message-handler/message-handler.service';
import { ClientNameService } from '@sharedModule/services/clientName/client-name.service';

const otpConstant = {
  otp: {
    type: 'text',
    key: 'otp',
    placeholder: '',
    imgURL: '',
    imgDes: '',
  },
};
@Component({
  selector: 'app-otp-verify',
  standalone: true,
  imports: [CommonModule, InputModule, FormsModule, ReactiveFormsModule],
  templateUrl: './otp-verify.component.html',
  styleUrl: './otp-verify.component.scss',
  providers: [LoginLayoutComponent],
})
export class OtpVerifyComponent implements OnInit, OnDestroy {
  email = this.authenticationService.loginSignal()?.email;

  phoneNumber: string = `${this.authenticationService.mobileOtpVerifyPayload()?.dialCode} -
    ${this.authenticationService.mobileOtpVerifyPayload()?.phone}`;
  @Input() otpnumber: number[] = [1, 2, 3, 4, 5, 6];
  otpTyped!: FormGroup;
  otpFormConstant = otpConstant;
  public fullWidth!: boolean;
  secondsLeft!: number;
  minutes!: any;
  onDestroy$: Subject<boolean> = new Subject();
  completedTimer: boolean = false;
  display: any;
  public timerInterval: any;
  #scheduledFocus: number | null = null;
  @ViewChildren('inputEl') inputEls!: QueryList<ElementRef<HTMLInputElement>>;
  onTouched?: () => void;
  emailLogin: boolean | null = null;
  @ViewChild('submit') submitButton!: ElementRef<HTMLButtonElement>;
clientName!:string|null;
#lastFocusedIndex: number = 0; // Track last focused input
  constructor(
    public loginLayouService: LoginLayoutService,
    public router: Router,
    public authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    public signupService: SignupService,
    public messageHandlerService: MessageHandlerService,
    public clientNameService:ClientNameService
  ) {
     
    this.otpTyped = new FormGroup({
      otp0: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      otp1: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      otp2: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      otp3: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      otp4: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      otp5: new FormControl('', [Validators.required,Validators.maxLength(1)]),
    });
  }

  ngOnInit(): void {
    this.timer(10);
  }
  timer(minute: number):void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = minute < 10 ? '0' : '';

    this.timerInterval = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.completedTimer = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }
  handleKeyDown(e: KeyboardEvent, idx: number):void {
    const input = e.target as HTMLInputElement;
    if ((e.key === 'Backspace' || e.key === 'Delete')&& !input.value) {
      if (idx > 0) {
        this.#scheduledFocus = idx - 1;
          // Schedule focus on the previous input
        setTimeout(() => {
          const prevInput = this.inputEls.toArray()[this.#scheduledFocus!].nativeElement;
          prevInput.focus();
          prevInput.select(); // Optional: Select content of previous input
          this.#scheduledFocus = null; // Reset scheduled focus
        }, 0);
      }
      
    }
  }
  handleSubmit(): void {
    if (this.otpTyped.valid) {
      const collectedOtp = `${this.otpTyped.value.otp0}${this.otpTyped.value.otp1}${this.otpTyped.value.otp2}${this.otpTyped.value.otp3}${this.otpTyped.value.otp4}${this.otpTyped.value.otp5}`;
      return this.otpVerify(collectedOtp);
    }
  }

  otpVerify(value: string):void {
    this.authenticationService
      .otpVerification(value)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: x => {
          if (x.success) {
            this.localStorageService.set('access_token', x.data.AccessToken);
            this.router.navigate(['/clientName/dashboard/publication']);
          }
        },
      });
  }


  handleInput(idx:number) {
    this.#updateWiredValue();

    if (this.#scheduledFocus != null) {
      this.#focusInput(this.#scheduledFocus);
      this.#scheduledFocus = null;
    }
    if (idx === this.otpnumber.length - 1 && this.otpTyped.valid) {      
      this.focusSubmitButton();
    }
   
  }

  handleKeyPress(e: KeyboardEvent, idx: number) {
    const isDigit = /\d/.test(e.key);

    // Safari fires Cmd + V through keyPress event as well
    // so we need to handle it here and let it through
    if (e.key === 'v' && e.metaKey) {
      return true;
    }

    if (isDigit && idx + 1 < this.otpnumber.length) {
      // If user inputs digits & we are not on the last input we want
      // to advance the focus
      this.#scheduledFocus = idx + 1;
    }
    

    return isDigit;
  }

  handleFocus(e: FocusEvent,idx: number) {
     this.#lastFocusedIndex = idx; // Update last focused input
    // Select previously entered value to replace with a new input
    (e.target as HTMLInputElement).select();
    
  }
    handleFocusOut(event: FocusEvent) {
    // If focus moves outside inputs, redirect to last focused input
  
      if ( this.#lastFocusedIndex === this.otpnumber.length - 1 && this.otpTyped.valid) {      
      this.focusSubmitButton();
    }
  }

  #focusInput(idx: number) {
    // In order not to interfere with the input we setTimeout
    // before advancing the focus
    setTimeout(() => this.inputEls.get(idx)?.nativeElement.focus());
  }

  ngAfterViewInit(): void {
  if (this.inputEls.length > 0) {
    this.#focusInput(0);
  }
}
  private focusSubmitButton(): void {
    setTimeout(() => {
      if (this.submitButton?.nativeElement) {
        this.submitButton.nativeElement.focus();       
      } else {
        console.warn('Submit button not found');
      }
    }, 0);
  }


  #updateWiredValue() {
    // We want to expose the value as a plain string
    // In order not to interfere with the input we setTimeout
    // before advancing the focus
    setTimeout(
      () =>
        `${this.otpTyped.value.otp0}${this.otpTyped.value.otp1}${this.otpTyped.value.otp3}${this.otpTyped.value.otp4}${this.otpTyped.value.otp5}`
    );
  }

  resendOtp(): void {
    this.otpTyped.reset();
    this.authenticationService.getResendOtp()
    .pipe(takeUntil(this.onDestroy$)).subscribe({
      next: x => {
        if (x.success) {
          this.completedTimer=false
          // TODO: SUCESSFULY SENT OTP
          this.messageHandlerService.show(x.message);
          this.authenticationService.loginSignal.update(prev => ({
            ...prev,
            session: x.data?.session,
          }));
        }
      },
    });
    this.timer(10);
  }

  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
    this.onDestroy$.next(true);
    this.onDestroy$.unsubscribe();
  }
}
